/* nt-gallery.js — controls two lightbox flavors:
   1) Portfolio project lightbox  (markup: sections/nt-portfolio-grid-v1.liquid)
      opener: [data-nt-lightbox-open][data-index]
   2) Sign-category variant photo viewer (markup: sections/nt-sign-category-variants-v1.liquid)
      opener: [data-nt-vlightbox-open][data-images='["url",...]'][data-title] */
window.NT = window.NT || {};

(function (NT) {
  var lb = { idx: 0, images: [], catL: '', title: '' };
  var vlb = { idx: 0, images: [], title: '' };

  function renderProjectLightbox() {
    var root = document.querySelector('[data-nt-lightbox]');
    if (!root) return;
    var item = lb.item;
    root.querySelector('[data-nt-lb-main]').src = lb.images[lb.idx];
    var catName = String(item.catL || '').split(' / ')[0];
    root.querySelector('[data-nt-lb-cat]').textContent = catName;
    root.querySelector('[data-nt-lb-title]').textContent = item.title;
    var descEl = root.querySelector('[data-nt-lb-desc]');
    if (descEl) descEl.textContent = 'A custom ' + item.title + ' fabricated in-house for a ' + catName + ' client — cut, wired and finished by hand, then shipped ready to mount.';
    var thumbWrap = root.querySelector('[data-nt-lb-thumbs]');
    thumbWrap.innerHTML = '';
    lb.images.forEach(function (url, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nt-pf-lb-thumb' + (i === lb.idx ? ' is-on' : '');
      b.setAttribute('data-idx', i);
      b.innerHTML = '<img src="' + url + '" alt="View photo">';
      thumbWrap.appendChild(b);
    });
    var quoteBtn = root.querySelector('[data-nt-lb-quote]');
    if (quoteBtn) {
      quoteBtn.setAttribute('data-nt-qd-open', item.typeL || item.title);
      quoteBtn.setAttribute('data-nt-qd-category', catName);
    }
  }

  function openProject(index) {
    if (!NT.Portfolio) return;
    var item = NT.Portfolio.byIndex(index);
    if (!item) return;
    lb.item = item;
    lb.images = [item.img].concat(item.gallery || []).filter(function (v, i, arr) { return arr.indexOf(v) === i; }).slice(0, 7);
    lb.idx = 0;
    renderProjectLightbox();
    var root = document.querySelector('[data-nt-lightbox]');
    if (root) { root.hidden = false; document.body.style.overflow = 'hidden'; }
  }
  function closeProject() {
    var root = document.querySelector('[data-nt-lightbox]');
    if (root) { root.hidden = true; document.body.style.overflow = ''; }
  }
  function stepProject(dir) {
    if (!lb.images.length) return;
    lb.idx = (lb.idx + dir + lb.images.length) % lb.images.length;
    renderProjectLightbox();
  }

  function renderVariantLightbox() {
    var root = document.querySelector('[data-nt-vlightbox]');
    if (!root) return;
    root.querySelector('[data-nt-vlb-title]').textContent = vlb.title;
    root.querySelector('[data-nt-vlb-main]').src = vlb.images[vlb.idx];
    var hasMulti = vlb.images.length > 1;
    root.querySelectorAll('[data-nt-vlb-multi]').forEach(function (el) { el.hidden = !hasMulti; });
    var thumbWrap = root.querySelector('[data-nt-vlb-thumbs]');
    if (thumbWrap) {
      thumbWrap.innerHTML = '';
      vlb.images.forEach(function (url, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nt-vlightbox-thumb' + (i === vlb.idx ? ' is-on' : '');
        b.setAttribute('data-idx', i);
        b.innerHTML = '<img src="' + url + '" alt="Photo ' + (i + 1) + '">';
        thumbWrap.appendChild(b);
      });
    }
    var quoteBtn = root.querySelector('[data-nt-vlb-quote]');
    if (quoteBtn) quoteBtn.setAttribute('data-nt-qd-open', vlb.title);
  }

  function openVariant(title, images) {
    vlb.title = title;
    vlb.images = (images || []).slice(0, 7);
    vlb.idx = 0;
    renderVariantLightbox();
    var root = document.querySelector('[data-nt-vlightbox]');
    if (root) { root.hidden = false; document.body.style.overflow = 'hidden'; }
  }
  function closeVariant() {
    var root = document.querySelector('[data-nt-vlightbox]');
    if (root) { root.hidden = true; document.body.style.overflow = ''; }
  }
  function stepVariant(dir) {
    if (!vlb.images.length) return;
    vlb.idx = (vlb.idx + dir + vlb.images.length) % vlb.images.length;
    renderVariantLightbox();
  }

  NT.Gallery = {
    openProject: openProject, closeProject: closeProject,
    openVariant: openVariant, closeVariant: closeVariant
  };

  document.addEventListener('click', function (e) {
    var pOpen = e.target.closest('[data-nt-lightbox-open]');
    if (pOpen) { openProject(parseInt(pOpen.getAttribute('data-index'), 10)); return; }
    if (e.target.closest('[data-nt-lb-close]')) { closeProject(); return; }
    if (e.target.closest('[data-nt-lb-prev]')) { stepProject(-1); return; }
    if (e.target.closest('[data-nt-lb-next]')) { stepProject(1); return; }
    if (e.target.closest('[data-nt-lb-quote]')) { closeProject(); }
    var thumb = e.target.closest('[data-nt-lb-thumbs] [data-idx]');
    if (thumb) { lb.idx = parseInt(thumb.getAttribute('data-idx'), 10); renderProjectLightbox(); return; }

    var vOpen = e.target.closest('[data-nt-vlightbox-open]');
    if (vOpen) {
      var images = [];
      try { images = JSON.parse(vOpen.getAttribute('data-images') || '[]'); } catch (err) {}
      openVariant(vOpen.getAttribute('data-title') || '', images);
      return;
    }
    if (e.target.closest('[data-nt-vlb-close]')) { closeVariant(); return; }
    if (e.target.closest('[data-nt-vlb-prev]')) { stepVariant(-1); return; }
    if (e.target.closest('[data-nt-vlb-next]')) { stepVariant(1); return; }
    if (e.target.closest('[data-nt-vlb-quote]')) { closeVariant(); }
    var vthumb = e.target.closest('[data-nt-vlb-thumbs] [data-idx]');
    if (vthumb) { vlb.idx = parseInt(vthumb.getAttribute('data-idx'), 10); renderVariantLightbox(); return; }
  });

  document.addEventListener('keydown', function (e) {
    var lbRoot = document.querySelector('[data-nt-lightbox]');
    var vlbRoot = document.querySelector('[data-nt-vlightbox]');
    if (lbRoot && !lbRoot.hidden) {
      if (e.key === 'Escape') closeProject();
      if (e.key === 'ArrowLeft') stepProject(-1);
      if (e.key === 'ArrowRight') stepProject(1);
    }
    if (vlbRoot && !vlbRoot.hidden) {
      if (e.key === 'Escape') closeVariant();
      if (e.key === 'ArrowLeft') stepVariant(-1);
      if (e.key === 'ArrowRight') stepVariant(1);
    }
  });
})(window.NT);
